export const OFFSET_UNITS = ['ms', 's'] as const;
export type OffsetUnit = (typeof OFFSET_UNITS)[number];

/** Pure string shift so unit round-trips are exact and don't drift through float math. */
export function convertOffsetUnit(
    duration: string,
    from: OffsetUnit,
    to: OffsetUnit,
): string {
    if (duration === '' || from === to) {
        return duration;
    }
    if (!/^-?(\d+(\.\d*)?|\.\d+)$/.test(duration)) {
        return duration;
    }
    const negative = duration.startsWith('-');
    const unsigned = negative ? duration.slice(1) : duration;
    const [intPart = '0', fracPart = ''] = unsigned.split('.');
    const digits = intPart + fracPart;
    const fracLen = fracPart.length;

    const newFracLen = from === 'ms' ? fracLen + 3 : Math.max(0, fracLen - 3);
    const padded =
        from === 'ms'
            ? digits.padStart(newFracLen + 1, '0')
            : digits + '0'.repeat(Math.max(0, 3 - fracLen));

    const splitAt = padded.length - newFracLen;
    const newInt = padded.slice(0, splitAt);
    const newFrac = padded.slice(splitAt);

    const trimmedInt = newInt.replace(/^0+/, '') || '0';
    const trimmedFrac = newFrac.replace(/0+$/, '');
    const result = trimmedFrac ? `${trimmedInt}.${trimmedFrac}` : trimmedInt;
    return negative && result !== '0' ? `-${result}` : result;
}
